import { updateAgentPrices } from '@/api/Topup/topup.api'
import { debounce } from 'debounce'
import Vue, { PropType } from 'vue'
import { mapState } from 'vuex'
import { GetProductDTO, TopUpPrice } from '../interfaces/topup.interface'
import { number } from '../validators'

export default Vue.extend({
  props: {
    product: {
      type: Object as PropType<GetProductDTO>,
      required: true,
    },
  },
  data() {
    return {
      priceReceived: 0,
      loadingConfig: false,
    }
  },
  computed: {
    ...mapState(['profile']),
    defaultCurrency() {
      if (this.product.code === 'CUCU') {
        return 'CUP'
      } else return 'USD'
    },
  },
  methods: {
    onInput(item: TopUpPrice) {
      if (!item.cost) return
      if (item.cost) {
        if (!number(item.cost.toString())) return
        if (item.cost < this.priceReceived && item.agent !== this.profile.uuid)
          return
      }
      if (item.price) {
        if (!number(item.price.toString())) return
        if (item.price < this.priceReceived) return
      }
      this.loadingConfig = true
      this.updatePrice(item, this)
    },
    updatePrice: debounce(async function(
      item: TopUpPrice,
      vm: Vue & { loadingConfig: boolean },
    ) {
      try {
        await updateAgentPrices(item)
      } finally {
        vm.loadingConfig = false
      }
    },
    1000),
  },
})
